export class PreviewError extends Error {
    constructor() {
        super('There was an error estimating the taxes for this transaction. \n Please try again later.');
    }
}
